/** Shared sidebar/mobile-nav "is this link active?" rule. Supports `#hash` links, `?tab=` links (every wanted
 *  query param must match), `exact`, `noQuery` (exact path with no query string) and `activePrefix` (child pages). */
export function navItemActive(item, location) {
  const [pathAndQuery, itemHash] = item.to.split("#");
  const [itemPath, itemQuery] = pathAndQuery.split("?");
  const currentHash = location.hash.replace("#", "");
  if (item.activePrefix && location.pathname.startsWith(item.activePrefix)) return true;
  if (itemQuery) {
    if (location.pathname !== itemPath) return false;
    const have = new URLSearchParams(location.search);
    return [...new URLSearchParams(itemQuery).entries()].every(([k, v]) => have.get(k) === v);
  }
  if (item.exact) return location.pathname === itemPath && (!item.noQuery || !location.search);
  if (itemHash) return location.pathname === itemPath && currentHash === itemHash;
  if (itemPath === "/") return location.pathname === "/" && !location.hash;
  return location.pathname.startsWith(itemPath) && !(currentHash && itemPath === location.pathname);
}

export const navPath = (to) => to.split(/[#?]/)[0];
